<cft-holy-grail-grid *transloco="let t">
  <cft-holy-grail-grid-col-left>
    <cft-holy-grail-sticky-wrapper>
      <bgo-region-directory-sidenav-industries class="pb-xl" [industries]="sideNavigationIndustries$ | async" />
      @if (topRegions$ | async; as topRegions) {
        <h3 class="pb-md text-center heading-lg md:text-left">
          {{ t('regionsDirectoryPage.sideNav.topRegions.heading', {numRegions: topRegions.length}) }}
        </h3>
        <div class="flex flex-wrap justify-center gap-sm pb-xl md:justify-start">
          @for (region of topRegions; track region.slug) {
            <a [routerLink]="region.slug">
              <cft-chip [outlined]="true" [colour]="'white'" [text]="region.regionName" class="cursor-pointer" />
            </a>
          }
        </div>
      }
      <bgo-region-directory-sidenav-direct-links />
    </cft-holy-grail-sticky-wrapper>
  </cft-holy-grail-grid-col-left>
  <cft-holy-grail-grid-content>
    <div class="plot-lg">{{ t('regionsDirectoryPage.plot') }}</div>
    <h1 class="pb-sm heading-2xl md:heading-4xl">{{ t('regionsDirectoryPage.title') }}</h1>
    <h1 class="pb-xl plot-sm">{{ t('regionsDirectoryPage.subtitle') }}</h1>
    @if (regions(); as regions) {
      <bgo-industries-and-regions
        [regions]="regions.value"
        [industries]="industries$ | async"
        [pagination]="regions.page"
        (pageOffsetChange)="regionPageOffsetChanged($event)"
      />
    }
    @if (content$ | async; as content) {
      @if (content.length > 0) {
        <div class="mt-2xl space-y-3xl md:mt-3xl md:space-y-20">
          @for (section of content; track $index) {
            @if (section.__type === 'ReviewSection') {
              <bgo-reviews-section
                [reviewSection]="section"
                (buttonClicked)="navigateToAboutUsPage()"
              ></bgo-reviews-section>
            } @else if (section.__type === 'KnowledgeSection') {
              <bgo-knowledge-section [knowledgeSection]="section"></bgo-knowledge-section>
            } @else if (section.__type === 'PromotionalBannerSection') {
              <bgo-promotional-banner-section [section]="section"></bgo-promotional-banner-section>
            } @else if (section.__type === 'InspirationSection') {
              <bgo-inspiration-section [inspirationSection]="section"></bgo-inspiration-section>
            } @else if (section.__type === 'ContentSection' && section.content.json) {
              <cft-content-section [title]="section.title" [plot]="section.plot" titleAlignment="left">
                <bgo-rich-text [content]="section.content"></bgo-rich-text>
              </cft-content-section>
            } @else if (section.__type === 'SignupSection') {
              <bgo-lead-signup-banner [section]="section"></bgo-lead-signup-banner>
            } @else if (section.__type === 'VideoSection') {
              <bgo-video-section [section]="section" />
            }
          }
        </div>
      }
    }
  </cft-holy-grail-grid-content>
</cft-holy-grail-grid>

<bgo-sticky-bottom-navigation [class.sticky-navigation-show]="showStickyFooter"></bgo-sticky-bottom-navigation>
